import {createAuth0Client} from '@auth0/auth0-spa-js';
import * as echarts from 'echarts';

const config=window.TEMPERATURE_CONFIG||{};
const views=['landing','loading','verification','app','deleted','verified','error'];
const customerViewTitles={
  overview:'Overview',
  temperature:'Temperature',
  alerts:'Alerts',
  sensors:'My sensors',
  profiles:'Parameters',
  subscriptions:'Subscription & billing',
  settings:'Settings',
};
let auth0;
let customerAuth0;
let staffMockAuth0;
let sensorsLoaded=false;
let temperatureChart=null;
let alertChart=null;
let monitoringTimer=null;
let temperatureRequest=0;
let alertRequest=0;
let customerDisplayUnit='fahrenheit';
let mockSession=false;
const $=selector=>document.querySelector(selector);
const $$=selector=>[...document.querySelectorAll(selector)];
const esc=value=>{
  const node=document.createElement('div');
  node.textContent=String(value??'');
  return node.innerHTML;
};

function show(id){
  for(const view of views)document.getElementById(view)?.classList.toggle('hidden',view!==id);
}

function setCustomerChrome(enabled){
  $('#public-header')?.classList.toggle('hidden',enabled);
  $('#public-footer')?.classList.toggle('hidden',enabled);
  document.body.classList.toggle('customer-session',enabled);
}

function message(text){
  const node=$('#message');
  node.textContent=text;
  node.classList.remove('hidden');
}

function closeCustomerMenu(){
  $('#customer-sidebar')?.classList.remove('open');
  $('#sidebar-backdrop')?.classList.add('hidden');
  const button=$('.mobile-menu-button');
  button?.setAttribute('aria-expanded','false');
}

function toggleCustomerMenu(){
  const sidebar=$('#customer-sidebar');
  const open=!sidebar.classList.contains('open');
  sidebar.classList.toggle('open',open);
  $('#sidebar-backdrop')?.classList.toggle('hidden',!open);
  $('.mobile-menu-button')?.setAttribute('aria-expanded',String(open));
}

function openCustomerView(name){
  if(!customerViewTitles[name])return;
  $$('[data-customer-panel]').forEach(panel=>panel.classList.toggle('hidden',panel.dataset.customerPanel!==name));
  $$('.customer-nav-item').forEach(item=>{
    const active=item.dataset.customerView===name;
    item.classList.toggle('active',active);
    if(active)item.setAttribute('aria-current','page');
    else item.removeAttribute('aria-current');
  });
  $('.settings-button')?.classList.toggle('active',name==='settings');
  $('#workspace-title').textContent=customerViewTitles[name];
  closeCustomerMenu();
  refreshMonitoringTimer(name);
  if(name==='sensors'&&!sensorsLoaded)loadSensors().catch(showError);
  if(name==='temperature')loadTemperature().catch(showError);
  if(name==='alerts')loadAlerts().catch(showError);
  if(name==='profiles')loadProfiles().catch(showError);
  if(name==='subscriptions')loadSubscription().catch(showError);
}

async function api(path,options={}){
  const token=await auth0.getTokenSilently();
  return fetch(`${config.apiBaseUrl}${path}`,{
    ...options,
    headers:{
      Authorization:`Bearer ${token}`,
      'Content-Type':'application/json',
      ...(options.headers||{}),
    },
  });
}

const staffMockStorageKey='temperature.staff-mock-login';
const customerWebSessionStorageKey='temperature.customer.web-session-id';

function customerWebSessionId(){
  let value=sessionStorage.getItem(customerWebSessionStorageKey);
  if(!value){
    value=crypto.randomUUID();
    sessionStorage.setItem(customerWebSessionStorageKey,value);
  }
  return value;
}

function isStaffMockAuthentication(){
  return isStaffMockEntry()||sessionStorage.getItem(staffMockStorageKey)==='1';
}

async function selectAuthentication(staffMock=isStaffMockAuthentication()){
  const cached=staffMock?staffMockAuth0:customerAuth0;
  if(cached){auth0=cached;return auth0;}
  const clientId=staffMock?config.auth0StaffClientId:config.auth0ClientId;
  if(!clientId)throw new Error('authentication_not_configured');
  const client=await createAuth0Client({
    domain:config.auth0Domain,
    clientId,
    cacheLocation:'memory',
    useRefreshTokens:false,
    authorizeTimeoutInSeconds:10,
    httpTimeoutInSeconds:10,
    authorizationParams:{
      redirect_uri:`${location.origin}/auth/callback`,
      audience:config.auth0Audience,
      scope:'openid profile email',
    },
  });
  if(staffMock)staffMockAuth0=client;
  else customerAuth0=client;
  auth0=client;
  return auth0;
}
async function login(signup=false,extra={},returnTo='/app',staffMock=false){
  if(staffMock)sessionStorage.setItem(staffMockStorageKey,'1');
  await selectAuthentication(staffMock);
  await auth0.loginWithRedirect({
    authorizationParams:{
      redirect_uri:`${location.origin}/auth/callback`,
      audience:config.auth0Audience,
      scope:'openid profile email',
      ...(signup?{screen_hint:'signup'}:{}),
      ...extra,
    },
    appState:{returnTo},
  });
}

function isStaffMockEntry(){
  return new URLSearchParams(location.search).get('mock')==='1';
}




function freshness(date){
  const minutes=Math.max(0,Math.floor((Date.now()-new Date(date).getTime())/60000));
  if(minutes<=30)return'Current';
  if(minutes<=60)return'Within one hour';
  if(minutes<360)return`Longer than ${Math.floor(minutes/60)} hours ago`;
  return`Longer than ${Math.floor(minutes/1440)||1} days ago`;
}

async function loadSensors(){
  const response=await api('/api/v1/me/sensors');
  if(!response.ok)throw new Error('sensors unavailable');
  const data=await response.json();
  sensorsLoaded=true;
  if(data.account_status==='suspended'){
    $('#suspended').classList.remove('hidden');
    $('#sensors').innerHTML='<p>Monitoring is suspended. Sensor data is temporarily unavailable.</p>';
    return data;
  }
  const node=$('#sensors');
  node.innerHTML=data.sensors.length
    ?data.sensors.map(sensor=>{
      const service=sensor.monitoring_status||'not_commissioned';
      const active=service==='active';
      const monitoring=active?`Monitoring active${sensor.pack_id?` · ${sensor.pack_id}`:''}`:service==='ended'?'Monitoring ended — contact support to renew':'Monitoring has not started';
      const label=sensor.sensor_label||sensor.source_device_id;
      const rename=mockSession?'':`<button class="sensor-rename-button" type="button" data-edit-sensor-label="${esc(sensor.id)}" aria-label="Rename ${esc(label)}" title="Rename sensor">✎</button>`;
      return `<article class="sensor" data-sensor-card="${esc(sensor.id)}"><div class="sensor-name-row"><span class="sensor-name-caption">Sensor name</span><strong>${esc(label)}</strong>${rename}</div>${mockSession?'':`<form class="sensor-label-editor hidden" data-sensor-label-form="${esc(sensor.id)}"><label>Sensor name<input maxlength="100" required value="${esc(label)}"></label><div class="inline-actions"><button class="button" type="submit">Save</button><button class="button secondary" type="button" data-cancel-sensor-label="${esc(sensor.id)}">Cancel</button></div></form>`}<p class="sensor-identifier">ID: ${esc(sensor.source_device_id)}</p><p>${esc((sensor.measurement_types||[]).join(', '))}</p><p class="sensor-freshness">${esc(monitoring)}</p>${active?`<p class="sensor-freshness">${freshness(sensor.last_seen_at)}</p><button class="button secondary" data-sensor="${esc(sensor.id)}">View readings</button>`:'<p class="muted">Live temperature and new alerts are unavailable while monitoring is not active.</p>'}</article>`;
    }).join('')
    :'<div class="empty-state compact"><h2>No sensors are assigned yet</h2><p>Your assigned sensors will appear here after commissioning.</p></div>';
  bindSensorLabelEditors();
  return data;
}

function bindSensorLabelEditors(){
  $$('[data-edit-sensor-label]').forEach(button=>button.onclick=()=>{
    const form=$(`[data-sensor-label-form="${button.dataset.editSensorLabel}"]`);
    form?.classList.remove('hidden');
    form?.querySelector('input')?.focus();
  });
  $$('[data-cancel-sensor-label]').forEach(button=>button.onclick=()=>{
    $(`[data-sensor-label-form="${button.dataset.cancelSensorLabel}"]`)?.classList.add('hidden');
  });
  $$('[data-sensor-label-form]').forEach(form=>form.onsubmit=async event=>{
    event.preventDefault();
    const sensorId=form.dataset.sensorLabelForm;
    const label=form.querySelector('input').value;
    const response=await api(`/api/v1/me/sensors/${encodeURIComponent(sensorId)}/label`,{
      method:'PATCH',body:JSON.stringify({sensor_label:label}),
    });
    if(!response.ok){
      const body=await response.json().catch(()=>({}));
      throw new Error(body.detail?.code||'sensor name could not be saved');
    }
    message('Sensor name saved.');
    await loadSensors();
    if(!$('.customer-view[data-customer-panel="temperature"]')?.classList.contains('hidden'))await loadTemperature();
    if(!$('.customer-view[data-customer-panel="alerts"]')?.classList.contains('hidden'))await loadAlerts();
  });
}

async function loadReadings(deviceId){
  const response=await api(`/api/v1/me/sensors/${deviceId}/readings?limit=100`);
  if(!response.ok)throw new Error('readings unavailable');
  const rows=await response.json();
  $('#reading-list').innerHTML=rows.map(reading=>`<div class="reading"><span>${esc(reading.measurement_type)}</span><strong>${esc(formatCustomerReading(reading))}</strong><time>${new Date(reading.received_at).toLocaleString()}</time></div>`).join('')||'<p>No readings in this assignment period.</p>';
  $('#readings').classList.remove('hidden');
}

function fahrenheit(milli){return ((Number(milli)/1000)*9/5+32).toFixed(1)}
function celsius(milli){return (Number(milli)/1000).toFixed(1)}
function displayTemperature(milli,unit='fahrenheit'){
  if(milli===null||milli===undefined||Number.isNaN(Number(milli)))return '—';
  return unit==='celsius'?`${celsius(milli)}°C`:`${fahrenheit(milli)}°F`;
}
function displayFahrenheit(value,unit='fahrenheit'){
  const number=Number(value);
  if(!Number.isFinite(number))return null;
  return unit==='celsius'?((number-32)*5/9):number;
}
function formatCustomerReading(reading){
  if(reading.measurement_type==='temperature'&&reading.numeric_value!==null&&reading.numeric_value!==undefined){
    return displayTemperature(Number(reading.numeric_value)*1000,customerDisplayUnit);
  }
  return `${reading.numeric_value??reading.text_value??'—'}${reading.unit?` ${reading.unit}`:''}`;
}
function sensorSelectionKey(){return `remote-touch.temperature.selected-sensors.${($('#customer-email')?.textContent||'anonymous').trim().toLowerCase()}`}
function selectedSensorIds(activeSensors){
  const stored=localStorage.getItem(sensorSelectionKey());
  if(stored===null)return activeSensors.map(sensor=>sensor.id);
  try{
    const selected=new Set(JSON.parse(stored));
    return activeSensors.map(sensor=>sensor.id).filter(id=>selected.has(id));
  }catch{return activeSensors.map(sensor=>sensor.id)}
}
function saveSensorSelection(ids){localStorage.setItem(sensorSelectionKey(),JSON.stringify([...new Set(ids)]));}
function renderTemperaturePicker(activeSensors,selected){
  const selectedSet=new Set(selected);
  $('#temperature-sensor-options').innerHTML=activeSensors.map(sensor=>`<label class="picker-option"><input type="checkbox" data-temperature-sensor value="${esc(sensor.id)}" ${selectedSet.has(sensor.id)?'checked':''}> <span>${esc(sensor.sensor_label||sensor.source_device_id)}</span></label>`).join('');
  $('#temperature-sensor-summary').textContent=selected.length===0?'No sensors selected':selected.length===activeSensors.length?'All sensors selected':`${selected.length} sensors selected`;
  $$('[data-temperature-sensor]').forEach(input=>input.onchange=()=>{
    const ids=$$('[data-temperature-sensor]:checked').map(item=>item.value);
    saveSensorSelection(ids);loadTemperature().catch(showError);
  });
  $('#temperature-select-all').onclick=()=>{saveSensorSelection(activeSensors.map(sensor=>sensor.id));loadTemperature().catch(showError)};
  $('#temperature-clear-all').onclick=()=>{saveSensorSelection([]);loadTemperature().catch(showError)};
}
let temperatureCharts=[];
let temperatureChartsBySensor=new Map();
const maximumTemperatureRangeMilliseconds=366*86400000;
// The range selector controls the width of the visible time window.  Charts
// retain context on either side so an operator can pan through history without
// changing that width.
let temperatureChartWindow=null;
let temperatureChartContext=null;
let temperatureChartHistories=[];
let temperatureChartUnit='fahrenheit';
let temperaturePanTimer=null;
let synchronizingTemperaturePan=false;
const temperatureChartDetailsBySensor=new Map();
const temperatureSeriesVisibilityBySensor=new Map();

function temperatureChartKey(history){return String(history.sensor_id||history.sensor_label||'temperature-chart');}

function temperatureChartDetails(history){
  const key=temperatureChartKey(history);
  if(!temperatureChartDetailsBySensor.has(key))temperatureChartDetailsBySensor.set(key,{workingRange:true,thresholds:true});
  return temperatureChartDetailsBySensor.get(key);
}

function formatTemperatureAxisValue(value){
  const numeric=Number(value);
  if(!Number.isFinite(numeric))return '—';
  const rounded=Math.round(numeric*10)/10;
  return `${Number.isInteger(rounded)?rounded:rounded.toFixed(1)}°`;
}

function temperatureDateTimeValue(value){
  const date=new Date(value);
  if(!Number.isFinite(date.getTime()))return '';
  return new Date(date.getTime()-date.getTimezoneOffset()*60000).toISOString().slice(0,16);
}

function setTemperatureRangeStatus(value=''){
  const status=$('#temperature-range-status');
  if(status)status.textContent=value;
}

function setTemperatureDateInputs(window){
  const start=$('#temperature-start'),end=$('#temperature-end');
  if(!start||!end)return;
  const latest=temperatureDateTimeValue(Date.now());
  start.max=latest;
  end.max=latest;
  start.value=temperatureDateTimeValue(window.start);
  end.value=temperatureDateTimeValue(window.end);
}

function temperaturePresetWindow(days=Number($('#temperature-range')?.value||1)){
  const end=Date.now();
  return {start:end-days*86400000,end};
}

function customTemperatureWindow(){
  const start=Date.parse($('#temperature-start')?.value||'');
  const end=Date.parse($('#temperature-end')?.value||'');
  if(!Number.isFinite(start)||!Number.isFinite(end)){
    setTemperatureRangeStatus('Choose both a start and end date and time.');
    return null;
  }
  if(start>=end){
    setTemperatureRangeStatus('The end must be later than the start.');
    return null;
  }
  if(end>Date.now()){
    setTemperatureRangeStatus('The end time cannot be in the future.');
    return null;
  }
  if(end-start>maximumTemperatureRangeMilliseconds){
    setTemperatureRangeStatus('Choose a range of 366 days or less.');
    return null;
  }
  setTemperatureRangeStatus();
  return {start,end};
}

function selectedTemperatureWindow(){
  if($('#temperature-range')?.value==='custom')return customTemperatureWindow();
  const window=temperaturePresetWindow();
  setTemperatureDateInputs(window);
  setTemperatureRangeStatus();
  return window;
}

function temperatureHistoryForWindow(histories,window){
  return histories.map(history=>({
    ...history,
    points:(history.points||[]).filter(point=>{
      const time=new Date(point.bucket_start).getTime();
      return Number.isFinite(time)&&time>=window.start&&time<window.end;
    }),
  }));
}

function temperatureEpoch(value){
  if(value instanceof Date)return value.getTime();
  const numeric=Number(value);
  if(Number.isFinite(numeric))return numeric;
  const parsed=Date.parse(value);
  return Number.isFinite(parsed)?parsed:NaN;
}

function temperatureWindowFromChart(chart){
  // ECharts keeps the live data-zoom window on the model.  `getOption()` can
  // retain the initial startValue/endValue after a mouse-wheel zoom. Prefer
  // the calculated window so the controls stay synchronized with the view.
  const calculated=chart.getModel()?.getComponent('dataZoom',0)?.getValueRange?.('x',0);
  const calculatedStart=temperatureEpoch(calculated?.[0]);
  const calculatedEnd=temperatureEpoch(calculated?.[1]);
  if(Number.isFinite(calculatedStart)&&Number.isFinite(calculatedEnd)&&calculatedEnd>calculatedStart){
    return {start:Math.round(calculatedStart),end:Math.round(calculatedEnd)};
  }
  const zoom=chart.getOption().dataZoom?.[0]||{};
  const axis=chart.getOption().xAxis?.[0]||{};
  const axisStart=temperatureEpoch(axis.min),axisEnd=temperatureEpoch(axis.max);
  let start=temperatureEpoch(zoom.startValue),end=temperatureEpoch(zoom.endValue);
  if((!Number.isFinite(start)||!Number.isFinite(end))&&Number.isFinite(axisStart)&&Number.isFinite(axisEnd)){
    start=axisStart+(axisEnd-axisStart)*(Number(zoom.start||0)/100);
    end=axisStart+(axisEnd-axisStart)*(Number(zoom.end||100)/100);
  }
  if(!Number.isFinite(start)||!Number.isFinite(end)||end<=start)return null;
  return {start:Math.round(start),end:Math.round(end)};
}

function sameTemperatureWindow(left,right,toleranceMilliseconds=1000){
  return Boolean(left&&right&&
    Math.abs(left.start-right.start)<=toleranceMilliseconds&&
    Math.abs(left.end-right.end)<=toleranceMilliseconds);
}

function synchronizeTemperatureCharts(source,window){
  synchronizingTemperaturePan=true;
  for(const chart of temperatureCharts){
    if(chart===source)continue;
    chart.dispatchAction({type:'dataZoom',dataZoomIndex:0,startValue:window.start,endValue:window.end});
  }
  synchronizingTemperaturePan=false;
}

function queueTemperaturePan(chart){
  clearTimeout(temperaturePanTimer);
  temperaturePanTimer=window.setTimeout(()=>{
    const window=temperatureWindowFromChart(chart);
    if(!window)return;
    // At a pan boundary ECharts can still emit an interaction even though the
    // locked window did not move.  There is nothing new to render or fetch.
    if(sameTemperatureWindow(window,temperatureChartWindow))return;
    temperatureChartWindow=window;
    $('#temperature-range').value='custom';
    setTemperatureDateInputs(window);
    setTemperatureRangeStatus();
    temperatureTableState.page=1;
    renderTemperatureTable(temperatureHistoryForWindow(temperatureChartHistories,window),temperatureChartUnit);
    const span=window.end-window.start;
    const threshold=Math.max(span*.08,300000);
    // The context's right edge is "now", so it cannot be extended by a
    // right-edge drag.  Only fetching at the earlier edge can reveal history
    // which was not already supplied to this chart.
    if(temperatureChartContext&&window.start<=temperatureChartContext.start+threshold){
      loadTemperature(window).catch(showError);
    }
  },180);
}

function disposeTemperatureChart(){
  for(const chart of temperatureCharts){
    try{chart.dispose();}catch{}
  }
  temperatureCharts=[];
  temperatureChartsBySensor.clear();
  temperatureChart=null;
}
function resizeTemperatureCharts(){
  for(const chart of temperatureCharts){
    try{chart.resize();}catch{}
  }
}
function disposeAlertChart(){if(alertChart){alertChart.dispose();alertChart=null;}}
function chartTheme(){return window.matchMedia('(prefers-color-scheme: dark)').matches?'dark':null}
function chartPalette(){return ['#087ea4','#c9542d','#7b61c9','#028a72','#b06020','#b23c75','#5274b9','#657d26'];}
function refreshMonitoringTimer(view){
  clearInterval(monitoringTimer);
  monitoringTimer=null;
  // Temperature charts stay exactly as the operator left them; refresh only
  // the alert feed in the background.
  if(view!=='alerts')return;
  monitoringTimer=window.setInterval(()=>{
    if(document.visibilityState!=='visible')return;
    loadAlerts().catch(error=>console.warn('automatic monitoring refresh failed',error));
  },60000);
}
function toChartValue(milli,unit){
  if(milli===null||milli===undefined)return null;
  return unit==='celsius'?Number(celsius(milli)):Number(fahrenheit(milli));
}
function temperatureChartOption(histories,unit,showNormal,showThresholds){
  const colors=chartPalette();
  const series=histories.map((history,index)=>{
    const visual=history.visual_parameters||{};
    const normalLow=displayFahrenheit(visual.normal_low_f,unit);
    const normalHigh=displayFahrenheit(visual.normal_high_f,unit);
    const high=displayFahrenheit(visual.high_open_threshold_f,unit);
    const low=displayFahrenheit(visual.low_open_threshold_f,unit);
    const seriesOption={
      name:history.sensor_label||history.sensor_id,type:'line',showSymbol:true,symbolSize:5,connectNulls:false,
      data:(history.points||[]).map(point=>({value:[point.bucket_start,toChartValue(point.average_milli_celsius,unit)],minimum:toChartValue(point.minimum_milli_celsius,unit),maximum:toChartValue(point.maximum_milli_celsius,unit),coverage:point.temperature_covered_seconds})),
      emphasis:{focus:'series'},lineStyle:{width:2.5},itemStyle:{color:colors[index%colors.length]},
    };
    // The working-temperature corridor is intentionally green for every
    // sensor. Series remain individually coloured, so this operationally
    // meaningful range does not get confused with a sensor's data line.
    if(showNormal&&normalLow!==null&&normalHigh!==null)seriesOption.markArea={silent:true,itemStyle:{color:'#23895c2b'},data:[[{yAxis:normalLow},{yAxis:normalHigh}]]};
    if(showThresholds){
      const lines=[];
      if(low!==null)lines.push({name:`${history.sensor_label||'Sensor'} low`,yAxis:low,lineStyle:{type:'dashed',color:'#3b7dd8'},label:{formatter:'Low'}});
      if(high!==null)lines.push({name:`${history.sensor_label||'Sensor'} high`,yAxis:high,lineStyle:{type:'dashed',color:'#d85427'},label:{formatter:'High'}});
      if(lines.length)seriesOption.markLine={symbol:'none',silent:true,data:lines};
    }
    return seriesOption;
  });
  return {
    animation:!window.matchMedia('(prefers-reduced-motion: reduce)').matches,color:colors,
    grid:{left:64,right:26,top:62,bottom:88,containLabel:false},legend:{type:'scroll',top:8},
    tooltip:{trigger:'axis',axisPointer:{type:'cross'},formatter:items=>{const at=items[0]?.value?.[0];const rows=items.map(item=>`${esc(item.seriesName)}: <strong>${Number(item.value?.[1]).toFixed(1)}°${unit==='celsius'?'C':'F'}</strong> <span>(${Number(item.data?.minimum).toFixed(1)}–${Number(item.data?.maximum).toFixed(1)}°)</span>`).join('<br>');return `<strong>${new Date(at).toLocaleString()}</strong><br>${rows}`;}},
    xAxis:{type:'time',name:'Time',nameLocation:'middle',nameGap:30,axisLabel:{hideOverlap:true}},
    yAxis:{type:'value',name:`Temperature °${unit==='celsius'?'C':'F'}`,scale:true,axisLabel:{formatter:value=>`${value}°`},splitLine:{lineStyle:{type:'dashed'}},},
    dataZoom:[{type:'inside',filterMode:'none'},{type:'slider',height:22,bottom:20,filterMode:'none'}],
    toolbox:{right:12,top:4,feature:{dataZoom:{yAxisIndex:'none'},restore:{}}},series,
  };
}
function renderTemperatureChart(histories,unit){
  const host=$('#temperature-chart');
  disposeTemperatureChart();
  if(!histories.length){
    host.innerHTML='<p class="muted">No sensor is selected.</p>';
    return;
  }
  host.innerHTML=`<div class="temperature-chart-stack">${histories.map((history,index)=>{
    const label=esc(history.sensor_label||history.sensor_id||`Sensor ${index+1}`);
    const key=temperatureChartKey(history);
    const details=temperatureChartDetails(history);
    const chartId=`temperature-echart-${index}`;
    const hasPoints=(history.points||[]).length>0;
    const contents=hasPoints
      ?`<div id="${chartId}" class="analytical-chart" role="img" aria-label="Temperature history for ${label}; drag horizontally to navigate and scroll to zoom the time range"></div>`
      :'<p class="muted temperature-chart-empty">No completed temperature analytics are available for this sensor and range yet.</p>';
    const controls=`<fieldset class="temperature-chart-controls"><legend>Chart details</legend><label><input type="checkbox" data-temperature-chart-detail="workingRange" data-temperature-chart-key="${esc(key)}" ${details.workingRange?'checked':''}> Working range</label><label><input type="checkbox" data-temperature-chart-detail="thresholds" data-temperature-chart-key="${esc(key)}" ${details.thresholds?'checked':''}> Thresholds</label></fieldset>`;
    return `<section class="temperature-chart-card" aria-labelledby="${chartId}-title"><div class="temperature-chart-heading"><h2 id="${chartId}-title">${label}</h2></div>${controls}${hasPoints?'<p class="chart-pan-hint">Drag left or right, or use the slider, to explore history. Scroll to zoom the time scale.</p>':''}${contents}</section>`;
  }).join('')}</div>`;
  histories.forEach((history,index)=>{
    if(!(history.points||[]).length)return;
    const key=temperatureChartKey(history),details=temperatureChartDetails(history),chartHost=$(`#temperature-echart-${index}`);
    const chart=echarts.init(chartHost,chartTheme(),{renderer:'canvas'});
    chart.setOption(temperatureChartOption([history],unit,details.workingRange,details.thresholds),true);
    chart.on('datazoom',()=>{
      if(synchronizingTemperaturePan)return;
      const window=temperatureWindowFromChart(chart);
      if(window)synchronizeTemperatureCharts(chart,window);
      queueTemperaturePan(chart);
    });
    chart.on('legendselectchanged',event=>{
      const seriesName=history.sensor_label||history.sensor_id;
      temperatureSeriesVisibilityBySensor.set(key,event.selected[seriesName]!==false);
    });
    temperatureCharts.push(chart);
    temperatureChartsBySensor.set(key,chart);
  });
  $$('[data-temperature-chart-detail]').forEach(input=>input.onchange=()=>{
    const key=input.dataset.temperatureChartKey,detail=input.dataset.temperatureChartDetail;
    const history=histories.find(item=>temperatureChartKey(item)===key),chart=temperatureChartsBySensor.get(key);
    if(!history||!chart)return;
    const details=temperatureChartDetails(history);
    details[detail]=input.checked;
    chart.setOption(temperatureChartOption([history],unit,details.workingRange,details.thresholds),true);
  });
  temperatureChart=temperatureCharts[0]||null;
}
function renderTemperatureTable(histories,unit){
  const rows=histories.flatMap(history=>(history.points||[]).map(point=>({label:history.sensor_label||history.sensor_id,point}))).sort((a,b)=>new Date(b.point.bucket_start)-new Date(a.point.bucket_start));
  $('#temperature-history-rows').innerHTML=rows.length?rows.map(({label,point})=>`<tr><td>${esc(label)}</td><td>${esc(new Date(point.bucket_start).toLocaleString())}</td><td>${displayTemperature(point.minimum_milli_celsius,unit)}</td><td>${displayTemperature(point.average_milli_celsius,unit)}</td><td>${displayTemperature(point.maximum_milli_celsius,unit)}</td><td>${Math.round(Number(point.temperature_covered_seconds||0)/60)} min</td></tr>`).join(''):'<tr><td colspan="6" class="muted">No completed temperature intervals are available for the selected sensors.</td></tr>';
}
async function loadTemperature(){
  // A selection/range change must win over a still-running automatic refresh.
  // We let the newer request proceed and discard every stale response.
  const request=++temperatureRequest;
  const response=await api('/api/v1/me/sensors');
  if(!response.ok)throw new Error('sensors unavailable');
  const data=await response.json();
  if(request!==temperatureRequest)return;
  const activeSensors=(data.sensors||[]).filter(sensor=>sensor.monitoring_status==='active'&&(sensor.measurement_types||[]).includes('temperature'));
  const selected=selectedSensorIds(activeSensors);
  renderTemperaturePicker(activeSensors,selected);
  if(!selected.length){
    disposeTemperatureChart();$('#temperature-freshness').textContent='Select one or more commissioned temperature sensors.';
    $('#temperature-chart').innerHTML='<p class="muted">No sensor is selected.</p>';
    $('#temperature-history-rows').innerHTML='<tr><td colspan="6" class="muted">Select sensors to view history.</td></tr>';
    return;
  }
  const days=Number($('#temperature-range').value),end=new Date(),start=new Date(end.getTime()-days*86400000);
  const histories=await Promise.all(selected.map(async deviceId=>{
    const historyResponse=await api(`/api/v1/me/temperature/${encodeURIComponent(deviceId)}?start=${encodeURIComponent(start.toISOString())}&end=${encodeURIComponent(end.toISOString())}`);
    if(!historyResponse.ok)throw new Error('temperature history unavailable');
    return historyResponse.json();
  }));
  if(request!==temperatureRequest)return;
  const primary=histories[0]?.visual_parameters?.display_unit||'fahrenheit';
  $('#temperature-freshness').textContent=histories.map(history=>`${history.sensor_label||'Sensor'}: ${String(history.freshness||'unavailable').replaceAll('_',' ')}`).join(' · ');
  renderTemperatureChart(histories,primary);
  renderTemperatureTable(histories,primary);
}
function alertChartOption(alerts,unit){
  const colors=chartPalette(),now=Date.now(),groups=new Map();
  alerts.slice().sort((a,b)=>new Date(a.opened_at)-new Date(b.opened_at)).forEach(alert=>{
    const key=`${alert.sensor_label||alert.source_device_id||'Sensor'} · ${alert.alarm_type}`;
    if(!groups.has(key))groups.set(key,[]);
    groups.get(key).push(alert);
  });
  const series=[...groups.entries()].map(([name,items],index)=>({
    name,type:'line',step:'end',showSymbol:true,symbolSize:7,lineStyle:{width:2.4},itemStyle:{color:colors[index%colors.length]},
    data:items.flatMap(alert=>[
      {value:[new Date(alert.opened_at).getTime(),1],alert},
      {value:[alert.cleared_at?new Date(alert.cleared_at).getTime():now,alert.cleared_at?0:1],alert},
    ]),
  }));
  return {animation:!window.matchMedia('(prefers-reduced-motion: reduce)').matches,color:colors,
    grid:{left:64,right:26,top:62,bottom:88},legend:{type:'scroll',top:8},
    tooltip:{trigger:'item',formatter:item=>{const a=item.data.alert;return `<strong>${esc(a.sensor_label||a.source_device_id||'Sensor')} · ${esc(a.alarm_type)} alarm</strong><br>Status: ${esc(a.state)} · Severity: ${esc(a.severity)}<br>Opened: ${new Date(a.opened_at).toLocaleString()} · ${displayTemperature(a.opened_value_milli_celsius,unit)}<br>${a.cleared_at?`Cleared: ${new Date(a.cleared_at).toLocaleString()} · ${displayTemperature(a.cleared_value_milli_celsius,unit)}<br>`:'Still open<br>'}Average: ${displayTemperature(a.average_value_milli_celsius,unit)}`;}},
    xAxis:{type:'time',name:'Time',nameLocation:'middle',nameGap:30},yAxis:{type:'value',name:'Alarm state',min:0,max:1,interval:1,axisLabel:{formatter:value=>value?'Alarm':'Clear'},splitLine:{show:false}},
    dataZoom:[{type:'inside',filterMode:'none'},{type:'slider',height:22,bottom:20,filterMode:'none'}],toolbox:{right:12,top:4,feature:{dataZoom:{yAxisIndex:'none'},restore:{}}},series,
  };
}
function renderAlerts(alerts){
  const unit='fahrenheit';
  disposeAlertChart();
  if(alerts.length){
    $('#alert-chart').innerHTML='<div id="alerts-echart" class="analytical-chart" role="img" aria-label="Interactive alarm timeline"></div>';
    alertChart=echarts.init($('#alerts-echart'),chartTheme(),{renderer:'canvas'});alertChart.setOption(alertChartOption(alerts,unit),true);
  }else $('#alert-chart').innerHTML='<p class="muted">No alerts match the selected filters.</p>';
  $('#alert-list').innerHTML=alerts.length?alerts.slice().sort((a,b)=>new Date(b.opened_at)-new Date(a.opened_at)).map(alarm=>{
    const durationEnd=alarm.cleared_at?new Date(alarm.cleared_at):new Date();
    const duration=Math.max(0,Math.round((durationEnd-new Date(alarm.opened_at))/60000));
    return `<article class="alert-card ${esc(alarm.state)}"><div class="alert-card-title"><strong>${esc(alarm.sensor_label||alarm.source_device_id||'Sensor')} · ${esc(alarm.alarm_type)} temperature alarm</strong><span>${esc(alarm.state)} · ${esc(alarm.severity)}</span></div><dl class="alert-details"><div><dt>Opened</dt><dd>${esc(new Date(alarm.opened_at).toLocaleString())} · ${displayTemperature(alarm.opened_value_milli_celsius,unit)}</dd></div><div><dt>Cleared</dt><dd>${alarm.cleared_at?`${esc(new Date(alarm.cleared_at).toLocaleString())} · ${displayTemperature(alarm.cleared_value_milli_celsius,unit)}`:'Open'}</dd></div><div><dt>Average temperature</dt><dd>${displayTemperature(alarm.average_value_milli_celsius,unit)}</dd></div><div><dt>Duration</dt><dd>${duration} min</dd></div></dl>${alarm.clear_reason?`<p class="muted">Clear reason: ${esc(alarm.clear_reason)}</p>`:''}</article>`;
  }).join(''):'<div class="empty-state compact"><h2>No alerts to show</h2><p>Your alert history will appear here after an alarm opens.</p></div>';
}
async function loadAlerts(){
  const request=++alertRequest;
  const days=Number($('#alerts-range').value),end=new Date(),start=new Date(end.getTime()-days*86400000);
  const response=await api(`/api/v1/me/alerts?start=${encodeURIComponent(start.toISOString())}&end=${encodeURIComponent(end.toISOString())}`);
  if(!response.ok)throw new Error('alerts unavailable');
  if(request!==alertRequest)return;
  const status=$('#alerts-status').value,severity=$('#alerts-severity').value,type=$('#alerts-type').value;
  const alerts=(await response.json()).filter(alert=>(status==='all'||alert.state===status)&&(severity==='all'||alert.severity===severity)&&(type==='all'||alert.alarm_type===type));
  renderAlerts(alerts);
}

function parameterForm(profile, formId){
  const p=profile.parameters, high=p.high, low=p.low;
  const number=(name,value,step='0.1')=>`<label>${esc(name)}<input type="number" step="${step}" required data-profile-field value="${esc(value)}"></label>`;
  const rule=(prefix,label,rule)=>`<fieldset class="profile-rule"><legend>${label} alarm</legend>
    <label class="check"><input type="checkbox" data-profile-field ${rule.enabled?'checked':''}>Enabled</label>
    ${number('Open threshold °F',rule.open_threshold_f)}${number('Clear threshold °F',rule.clear_threshold_f)}
    ${number('Open readings required',rule.required_count,'1')}${number('Open duration seconds',rule.required_duration_seconds,'1')}
    ${number('Clear readings required',rule.clear_required_count,'1')}${number('Clear duration seconds',rule.clear_required_duration_seconds,'1')}
  </fieldset>`;
  return `<form id="${formId}" class="profile-form" data-profile-id="${profile.profile_id}">
    <p><strong>${esc(profile.sensor_label||profile.source_device_id)}</strong> · ${esc(profile.template_pack_id)} · revision ${esc(profile.revision)}</p>
    <div class="profile-grid">
      <label>Display unit<select data-profile-field><option value="fahrenheit" ${p.display_unit==='fahrenheit'?'selected':''}>Fahrenheit</option><option value="celsius" ${p.display_unit==='celsius'?'selected':''}>Celsius</option></select></label>
      ${number('Working temperature °F',p.nominal_temperature_f)}${number('Normal low °F',p.normal_low_f)}${number('Normal high °F',p.normal_high_f)}
      ${number('Freshness minutes',Math.round(p.freshness_seconds/60),'1')}
    </div><div class="profile-rules">${rule('high','High',high)}${rule('low','Low',low)}</div>
    <button class="button" type="submit">Save parameters</button><p class="muted">Saving creates a new profile revision, clears any open alarm, and starts fresh evaluation using these parameters.</p>
  </form>`;
}

function parametersFromForm(form){
  const fields=[...form.querySelectorAll('[data-profile-field]')];
  const value=i=>fields[i].type==='checkbox'?fields[i].checked:fields[i].value;
  const n=i=>Number(value(i));
  return {display_unit:value(0),nominal_temperature_f:n(1),normal_low_f:n(2),normal_high_f:n(3),freshness_seconds:n(4)*60,
    high:{enabled:value(5),open_threshold_f:n(6),clear_threshold_f:n(7),required_count:n(8),required_duration_seconds:n(9),clear_required_count:n(10),clear_required_duration_seconds:n(11)},
    low:{enabled:value(12),open_threshold_f:n(13),clear_threshold_f:n(14),required_count:n(15),required_duration_seconds:n(16),clear_required_count:n(17),clear_required_duration_seconds:n(18)}};
}

async function loadProfiles(){
  const response=await api('/api/v1/me/runtime-profiles');
  if(!response.ok)throw new Error('monitoring parameters unavailable');
  const profiles=await response.json(), host=$('#profile-editor');
  if(!profiles.length){host.innerHTML='<p class="muted">No commissioned sensor profile is available yet.</p>';return}
  host.innerHTML=`<label>Sensor<select id="profile-sensor">${profiles.map(profile=>`<option value="${esc(profile.profile_id)}">${esc(profile.sensor_label||profile.source_device_id)} · ${esc(profile.template_pack_id)}</option>`).join('')}</select></label><div id="profile-form-host"></div>`;
  const render=()=>{const selected=profiles.find(item=>item.profile_id===$('#profile-sensor').value);$('#profile-form-host').innerHTML=parameterForm(selected,'customer-profile-form');bindCustomerProfileForm()};
  $('#profile-sensor').onchange=render;render();
}

function bindCustomerProfileForm(){
  const form=$('#customer-profile-form');
  if(mockSession){form.querySelectorAll('input,select,button').forEach(control=>control.disabled=true);return;}
  form.onsubmit=async event=>{event.preventDefault();const response=await api(`/api/v1/me/runtime-profiles/${form.dataset.profileId}`,{method:'PATCH',body:JSON.stringify({parameters:parametersFromForm(form)})});if(!response.ok){const body=await response.json().catch(()=>({}));throw new Error(body.detail?.code||'parameters could not be saved')}message('Parameters saved. Monitoring now uses the new profile revision.');await loadProfiles()};
}

function money(minor,currency='USD'){
  return new Intl.NumberFormat(undefined,{style:'currency',currency}).format(Number(minor||0)/100);
}

function subscriptionActionLabel(plan,current,count){
  if(!current)return plan.subscription_kind==='connectivity'?'Add cellular service':'Choose plan';
  if(plan.code===current.plan_code)return 'Current plan';
  if(plan.subscription_kind==='connectivity')return 'Manage in billing';
  if(plan.maximum_active_logical_sensors>current.maximum_active_logical_sensors)return 'Upgrade in billing';
  return count<=plan.maximum_active_logical_sensors?'Schedule downgrade in billing':'Reduce monitored sensors first';
}

function subscriptionPlanCard(plan,data){
  const connectivity=plan.subscription_kind==='connectivity';
  const current=connectivity?data.connectivity_subscription:data.subscription;
  const selected=current?.plan_code===plan.code;
  const monthly=plan.offerings.find(offer=>offer.billing_interval==='month');
  const annual=plan.offerings.find(offer=>offer.billing_interval==='year');
  const observed=connectivity?1:data.active_logical_sensor_count;
  const action=subscriptionActionLabel(plan,current,observed);
  const eligible=connectivity||observed<=plan.maximum_active_logical_sensors;
  const defaultOffer=monthly||annual;
  const checkoutActionable=data.can_manage&&data.billing.checkout_available&&defaultOffer?.checkout_available&&!selected&&!current&&eligible;
  const portalActionable=data.can_manage&&data.billing.portal_available&&current?.provider_customer_id&&!selected&&eligible;
  const actionable=checkoutActionable||portalActionable;
  const cycleOptions=[monthly,annual].filter(Boolean).map(offer=>`<option value="${esc(offer.id)}" ${offer.billing_interval==='month'?'selected':''}>${offer.billing_interval==='year'?'Yearly':'Monthly'} · ${money(offer.price_minor,offer.currency_code)}</option>`).join('');
  const capacity=connectivity
    ?'One Remote Touch managed cellular gateway connection per customer account'
    :`${plan.minimum_active_logical_sensors}–${plan.maximum_active_logical_sensors} monitored logical ${plan.maximum_active_logical_sensors===1?'source':'sources'}`;
  const includes=connectivity
    ?'4G/5G LTE connectivity for the approved Remote Touch gateway. Modem hardware and installation are separate.'
    :`Includes: ${esc((plan.included_alert_families||[]).join(', '))} alerts`;
  return `<article class="subscription-plan ${selected?'current':''}">
    <div class="subscription-plan-header"><h3>${esc(plan.name)}</h3>${selected?'<span class="subscription-badge">Current</span>':''}</div>
    <p class="subscription-capacity">${capacity}</p>
    <div class="subscription-price"><strong>${monthly?money(monthly.price_minor,monthly.currency_code):'—'}</strong><span>/ month</span></div>
    <p class="subscription-annual">${annual?`${money(annual.price_minor,annual.currency_code)} yearly · two months free`:'Annual price pending'}</p>
    <p class="subscription-includes">${includes}</p>
    <label class="subscription-cycle">Billing interval<select data-subscription-cycle="${esc(plan.id)}" ${selected?'disabled':''}>${cycleOptions}</select></label>
    <button class="button ${selected?'secondary':''}" type="button" ${checkoutActionable?`data-subscription-plan="${esc(plan.id)}"`:portalActionable?`data-subscription-portal="${esc(plan.subscription_kind)}"`:''} ${actionable?'':'disabled'}>${esc(action)}</button>
    ${!eligible&&!selected?'<p class="subscription-help">This plan is below your current monitored-source count.</p>':''}
  </article>`;
}

function billingSummary({kind,current,data}){
  const connectivity=kind==='connectivity';
  const capacity=current?.maximum_active_logical_sensors;
  const remaining=capacity===undefined?null:Math.max(0,capacity-data.active_logical_sensor_count);
  const currentStatus=current
    ?`${esc(current.plan_name)} · ${esc(current.status.replaceAll('_',' '))}`
    :connectivity?'No cellular connectivity subscription':'No active subscription';
  const renewal=current?.current_period_end?new Date(current.current_period_end).toLocaleDateString():'—';
  const text=connectivity
    ?(current?'This account has a separate managed cellular service agreement for its approved Remote Touch gateway.':'Wi-Fi remains free to use. Add this optional service only when Remote Touch supplies the approved cellular gateway.')
    :(current?`You are monitoring ${data.active_logical_sensor_count} of ${capacity} available logical sources${remaining===null?'':`; ${remaining} remain`}.`:`You have ${data.active_logical_sensor_count} monitored logical sources. Choose a capacity plan before commercial billing begins.`);
  return `<section class="subscription-summary subscription-summary-${kind}">
    <div><p class="eyebrow">${connectivity?'Optional managed connectivity':'Your monitoring service'}</p><h2>${currentStatus}</h2><p>${text}</p></div>
    <div class="subscription-summary-actions">
      ${current&&data.can_manage&&data.billing.portal_available&&current.provider_customer_id?`<button class="button secondary" type="button" data-open-billing-portal="${kind}">Manage billing</button>`:''}
      <span class="subscription-renewal">${current?.status==='cancel_at_period_end'?`Ends ${renewal}`:current?`Renews ${renewal}`:'Plans are billed monthly or yearly'}</span>
    </div>
  </section>`;
}

function renderSubscription(data){
  const host=$('#subscription-content');
  const billing=data.billing||{};
  const monitoringPlans=(data.plans||[]).filter(plan=>plan.subscription_kind==='monitoring');
  const connectivityPlans=(data.plans||[]).filter(plan=>plan.subscription_kind==='connectivity');
  host.innerHTML=`
    ${billingSummary({kind:'monitoring',current:data.subscription,data})}
    ${data.can_manage?'': '<p class="subscription-notice">Only the account owner can change a subscription. Staff mock access is read-only.</p>'}
    ${billing.checkout_available?'':'<p class="subscription-notice">Payments are not connected yet. You can review plans now; checkout becomes available after Remote Touch Paddle setup is complete.</p>'}
    <section class="subscription-section"><div class="subscription-section-heading"><div><p class="eyebrow">Monitoring capacity</p><h2>Choose your monitored-source capacity</h2></div><p>Annual billing includes two months free.</p></div><div class="subscription-plan-grid">${monitoringPlans.map(plan=>subscriptionPlanCard(plan,data)).join('')}</div></section>
    <section class="subscription-section connectivity-section"><div class="subscription-section-heading"><div><p class="eyebrow">Cellular service</p><h2>Managed 4G/5G connectivity</h2><p>Independent from monitoring capacity. It covers one approved Remote Touch cellular gateway when Wi-Fi is unavailable or the account chooses managed connectivity.</p></div><p>Optional · billed separately</p></div>${billingSummary({kind:'connectivity',current:data.connectivity_subscription,data})}<div class="subscription-plan-grid">${connectivityPlans.map(plan=>subscriptionPlanCard(plan,data)).join('')}</div></section>
    <section class="subscription-section subscription-invoices"><div class="subscription-section-heading"><div><p class="eyebrow">Billing history</p><h2>Invoices</h2></div></div>
      ${(data.invoices||[]).length?`<div class="subscription-table-wrap"><table><thead><tr><th>Service</th><th>Issued</th><th>Invoice</th><th>Status</th><th>Total</th></tr></thead><tbody>${data.invoices.map(invoice=>`<tr><td>${esc(invoice.subscription_kind==='connectivity'?'Cellular service':'Monitoring')}</td><td>${invoice.issued_at?new Date(invoice.issued_at).toLocaleDateString():'—'}</td><td>${esc(invoice.invoice_number||'—')}</td><td>${esc(invoice.status)}</td><td>${invoice.total_minor===null||invoice.total_minor===undefined?'—':money(invoice.total_minor,invoice.currency_code)}</td></tr>`).join('')}</tbody></table></div>`:'<p class="muted">Invoices appear here after a successful payment.</p>'}
    </section>`;
  document.querySelectorAll('[data-subscription-plan]').forEach(button=>button.onclick=()=>{const offering=$(`[data-subscription-cycle="${button.dataset.subscriptionPlan}"]`)?.value;startSubscriptionCheckout(offering);});
  document.querySelectorAll('[data-subscription-portal]').forEach(button=>button.onclick=()=>openSubscriptionPortal(button.dataset.subscriptionPortal));
  document.querySelectorAll('[data-open-billing-portal]').forEach(button=>button.onclick=()=>openSubscriptionPortal(button.dataset.openBillingPortal));
}

async function loadSubscription(){
  const response=await api('/api/v1/me/subscription');
  if(!response.ok)throw new Error('subscription information unavailable');
  const data=await response.json();
  renderSubscription(data);
}

async function startSubscriptionCheckout(offeringId){
  if(!offeringId||mockSession)return;
  if(!window.confirm('Continue to Paddle Checkout to review your subscription and payment before completing purchase?'))return;
  const response=await api('/api/v1/me/subscription/checkout',{
    method:'POST',headers:{'Idempotency-Key':crypto.randomUUID(),'X-Correlation-ID':crypto.randomUUID()},
    body:JSON.stringify({offering_id:offeringId}),
  });
  if(!response.ok){const body=await response.json().catch(()=>({}));throw new Error(body.detail?.code||'subscription checkout unavailable');}
  const data=await response.json();
  if(!data.checkout_url)throw new Error('subscription checkout unavailable');
  location.assign(data.checkout_url);
}

async function openSubscriptionPortal(subscriptionKind='monitoring'){
  if(mockSession)return;
  const response=await api('/api/v1/me/subscription/portal',{
    method:'POST',body:JSON.stringify({subscription_kind:subscriptionKind}),
  });
  if(!response.ok){const body=await response.json().catch(()=>({}));throw new Error(body.detail?.code||'billing portal unavailable');}
  const data=await response.json();
  if(!data.url)throw new Error('billing portal unavailable');
  location.assign(data.url);
}

async function loadReleaseVersion(){
  const target=$('#customer-version');
  if(!target)return;
  try{
    const response=await fetch('/release.json',{cache:'no-store'});
    if(!response.ok)throw new Error('release manifest unavailable');
    const release=await response.json();
    if(!/^\d+\.\d+\.\d+$/.test(release.application_version))throw new Error('invalid release manifest');
    target.textContent=`v${release.application_version}`;
  }catch{
    target.textContent='v—';
  }
}

async function bootstrap(){
  const response=await api('/api/v1/session/bootstrap',{
    method:'POST',headers:{'X-Customer-Session-ID':customerWebSessionId()},
  });
  if(!response.ok){
    const body=await response.json().catch(()=>({}));
    const code=body.error?.code||body.detail?.code;
    if(code==='email_verification_required'){
      setCustomerChrome(false);
      show('verification');
      return;
    }
    throw new Error(code||'account unavailable');
  }
  const data=await response.json();
  mockSession=Boolean(data.mock_session?.active&&data.mock_session?.read_only);
  const mockBanner=$('#mock-session-banner');
  if(mockSession){
    mockBanner.textContent=`Staff mock access — read-only view of ${data.mock_session.mirrored_customer_account_display_name||'the selected customer'}.`;
    mockBanner.classList.remove('hidden');
  }else mockBanner.classList.add('hidden');
  const email=data.user.email;
  const status=data.account.status;
  $('#customer-email').textContent=email;
  $('#settings-email').textContent=email;
  $('#customer-account-status').textContent=status;
  $('#settings-status').textContent=status;
  const authentication=data.authentication||{};
  const passwordSupported=authentication.password_change_supported===true;
  const credentialProvider=authentication.credential_provider||'your sign-in provider';
  $('#settings-sign-in').textContent=passwordSupported?'Email and password':credentialProvider;
  $('#password-action').classList.toggle('hidden',!passwordSupported||mockSession);
  $('#external-password').classList.toggle('hidden',passwordSupported||mockSession);
  $('#credential-provider').textContent=credentialProvider;
  $('#credential-provider-link').classList.toggle('hidden',credentialProvider!=='Google');
  await loadCustomerDisplayPreference();
  bindCustomerDisplayPreference();
  if(mockSession){
    $('#display-preferences-form').querySelectorAll('select,button').forEach(control=>control.disabled=true);
    $('#settings-display-status').textContent='Mock access is read-only. Measurement settings belong to the customer account.';
    $('.danger-zone')?.classList.add('hidden');
  }else $('.danger-zone')?.classList.remove('hidden');
  if(status==='suspended')$('#suspended').classList.remove('hidden');
  setCustomerChrome(true);
  show('app');
  openCustomerView('overview');
}

async function verifyContact(){
  const token=new URLSearchParams(location.search).get('token');
  if(!token)throw new Error('verification token missing');
  const response=await fetch(`${config.apiBaseUrl}/api/v1/contact-verifications/${encodeURIComponent(token)}`,{method:'POST'});
  if(!response.ok)throw new Error('verification link invalid');
  show('verified');
}

async function route(){
  setCustomerChrome(false);
  show('loading');
  if(location.pathname==='/account-deleted'){
    show('deleted');
    return;
  }
  if(location.pathname==='/verify-contact'){
    await verifyContact();
    return;
  }
  if(location.pathname==='/auth/callback'&&location.search.includes('code=')){
    const staffMock=isStaffMockAuthentication();
    await selectAuthentication(staffMock);
    const result=await auth0.handleRedirectCallback();
    if(staffMock)sessionStorage.removeItem(staffMockStorageKey);
    history.replaceState({},'',result.appState?.returnTo||'/app');
  }
  const authenticated=await auth0.isAuthenticated();
  if(location.pathname==='/app'||location.pathname==='/auth/callback'){
    if(!authenticated){
      if(isStaffMockEntry()){
        if(!config.auth0StaffConnection||!config.auth0StaffClientId)throw new Error('staff_mock_login_unavailable');
        // Mock sessions are issued to the staff Auth0 application, never the
        // customer one. This retains the staff identity and lets the API apply
        // its explicit read-only customer mapping.
        await login(false,{connection:config.auth0StaffConnection},'/app?mock=1',true);
      }else{
        await login();
      }
      return;
    }
    await bootstrap();
    return;
  }
  show('landing');
}

async function handleAction(action){
  // A user who deliberately selects Log in or Create account must see Auth0's
  // available methods even when another Auth0 SSO session is already active.
  // Automatic entry to the protected /app route can still reuse SSO.
  if(action==='login')return login(false,{prompt:'login'});
  if(action==='signup')return login(true,{prompt:'login'});
  if(action==='customer-menu'){
    toggleCustomerMenu();
    return;
  }
  if(action==='load-temperature')return loadTemperature();
  if(action==='logout'){
    return auth0.logout({logoutParams:{returnTo:location.origin}});
  }
  if(action==='reactivate'){
    const response=await api('/api/v1/me/reactivation-requests',{method:'POST'});
    message(response.ok?'Reactivation request received.':'The request could not be completed.');
    return;
  }
  if(action==='password'){
    const response=await api('/api/v1/me/password-change',{method:'POST'});
    if(response.status===409){
      message('Your password is managed by your sign-in provider.');
      return;
    }
    message(response.ok?'Check your email for the password-change link.':'The request could not be completed.');
    return;
  }
  if(action==='prepare-delete'){
    const claims=await auth0.getIdTokenClaims();
    const age=Math.floor(Date.now()/1000)-Number(claims?.auth_time||0);
    if(!claims?.auth_time||age>240){
      await login(false,{max_age:0,prompt:'login'});
      return;
    }
    $('#delete-form').classList.remove('hidden');
    return;
  }
  if(action==='delete'){
    const response=await api('/api/v1/me',{
      method:'DELETE',
      headers:{'Idempotency-Key':crypto.randomUUID()},
      body:JSON.stringify({confirmation:$('#delete-confirmation').value}),
    });
    if(response.status===204){
      await auth0.logout({logoutParams:{returnTo:`${location.origin}/account-deleted`}});
      return;
    }
    if(response.status===401){
      await login(false,{max_age:0,prompt:'login'});
      return;
    }
    message('Deletion could not be completed. Please try again.');
  }
}

function showError(error){
  console.error(error);
  setCustomerChrome(false);
  show('error');
  const messages={
    identity_link_exception:'This email is already registered to another Remote Touch identity. Staff and customer accounts must use different email addresses.',
    account_disabled:'This customer account is unavailable. Try logging in again or contact support.',
    staff_mock_access_not_configured:'Mock customer access is not enabled for this staff account. Ask an administrator to assign a customer in the Staff workspace.',
    staff_mock_login_unavailable:'Staff mock sign-in is temporarily unavailable. Please try again later.',
    authentication_required:'Your login session expired. Please log in again.',
    Timeout:'The authentication service did not respond. Please try logging in again.',
  };
  $('#error-message').textContent=messages[error.message]||'Please return home and try again.';
}

async function start(){
  void loadReleaseVersion();
  const link=document.createElement('link');
  link.rel='stylesheet';
  link.href='/monitoring.css?v=1.2.3';
  document.head.append(link);
  if(!config.auth0Domain||!config.auth0ClientId||!config.auth0Audience){
    show('error');
    $('#error-message').textContent='Authentication is not configured.';
    return;
  }
  await selectAuthentication();
  $('#temperature-range').onchange=()=>{
    if($('#temperature-range').value==='custom'){
      if(!$('#temperature-start').value||!$('#temperature-end').value)setTemperatureDateInputs(temperaturePresetWindow(1));
      const window=customTemperatureWindow();
      if(window)loadTemperature(window).catch(showError);
      return;
    }
    const window=selectedTemperatureWindow();
    if(window)loadTemperature(window).catch(showError);
  };
  const updateCustomTemperatureRange=()=>{
    $('#temperature-range').value='custom';
    const window=customTemperatureWindow();
    if(window)loadTemperature(window).catch(showError);
  };
  $('#temperature-start').onchange=updateCustomTemperatureRange;
  $('#temperature-end').onchange=updateCustomTemperatureRange;
  $('#alerts-range').onchange=()=>loadAlerts().catch(showError);
  $('#alerts-status').onchange=()=>loadAlerts().catch(showError);
  $('#alerts-severity').onchange=()=>loadAlerts().catch(showError);
  $('#alerts-type').onchange=()=>loadAlerts().catch(showError);
  window.addEventListener('resize',()=>{resizeTemperatureCharts();alertChart?.resize();});
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change',()=>{
    if(!$('.customer-view[data-customer-panel="temperature"]')?.classList.contains('hidden'))loadTemperature().catch(showError);
    if(!$('.customer-view[data-customer-panel="alerts"]')?.classList.contains('hidden'))loadAlerts().catch(showError);
  });
  document.addEventListener('click',event=>{
    const viewControl=event.target.closest('[data-customer-view]');
    if(viewControl){
      event.preventDefault();
      openCustomerView(viewControl.dataset.customerView);
      return;
    }
    const sensor=event.target.closest('[data-sensor]')?.dataset.sensor;
    if(sensor){
      loadReadings(sensor).catch(showError);
      return;
    }
    const action=event.target.closest('[data-action]')?.dataset.action;
    if(action)handleAction(action).catch(showError);
  });
  await route();
}

start().catch(showError);

let pendingTemperatureSensorIds=null;const temperatureTableState={page:1,pageSize:10,rows:[]};const alertListState={page:1,pageSize:10,rows:[]};function selectionSummary(selected,total){return selected.length===0?'No sensors selected':selected.length===total?'All sensors selected':`${selected.length} sensors selected`;}function selectedPickerIds(){return $$('[data-temperature-sensor]:checked').map(item=>item.value);}function v09RenderTemperaturePicker(activeSensors,selected){const pending=new Set(pendingTemperatureSensorIds===null?selected:pendingTemperatureSensorIds);$('#temperature-sensor-options').innerHTML=activeSensors.map(sensor=>`<label class='picker-option'><input type='checkbox' data-temperature-sensor value='${esc(sensor.id)}' ${pending.has(sensor.id)?'checked':''}> <span>${esc(sensor.sensor_label||sensor.source_device_id)}</span></label>`).join('');$('#temperature-sensor-summary').textContent=selectionSummary(selected,activeSensors.length);const picker=$('#temperature-sensor-picker');picker.ontoggle=()=>{if(!picker.open)pendingTemperatureSensorIds=null;};$$('[data-temperature-sensor]').forEach(input=>input.onchange=()=>{pendingTemperatureSensorIds=selectedPickerIds();});$('#temperature-select-all').onclick=()=>{pendingTemperatureSensorIds=activeSensors.map(sensor=>sensor.id);$$('[data-temperature-sensor]').forEach(input=>input.checked=true);};$('#temperature-clear-all').onclick=()=>{pendingTemperatureSensorIds=[];$$('[data-temperature-sensor]').forEach(input=>input.checked=false);};$('#temperature-apply-selection').onclick=()=>{saveSensorSelection(selectedPickerIds());pendingTemperatureSensorIds=null;temperatureTableState.page=1;picker.open=false;loadTemperature().catch(showError);};}function paginationMarkup(prefix,state,total){const pages=Math.max(1,Math.ceil(total/state.pageSize));state.page=Math.min(Math.max(1,state.page),pages);const first=total?(state.page-1)*state.pageSize+1:0,last=Math.min(total,state.page*state.pageSize);return `<div class='list-pagination' aria-label='${esc(prefix)} pagination'><label>Rows<select data-page-size='${esc(prefix)}'>${[10,25,50,100].map(size=>`<option value='${size}' ${state.pageSize===size?'selected':''}>${size}</option>`).join('')}</select></label><span>${total?`${first}–${last} of ${total}`:'0 results'} · Page ${state.page} of ${pages}</span><button class='secondary pagination-button' type='button' data-page-previous='${esc(prefix)}' ${state.page<=1?'disabled':''}>Previous</button><button class='secondary pagination-button' type='button' data-page-next='${esc(prefix)}' ${state.page>=pages?'disabled':''}>Next</button></div>`;}function bindPagination(prefix,state,render){$(`[data-page-size='${prefix}']`).onchange=event=>{state.pageSize=Number(event.target.value);state.page=1;render();};$(`[data-page-previous='${prefix}']`).onclick=()=>{state.page=Math.max(1,state.page-1);render();};$(`[data-page-next='${prefix}']`).onclick=()=>{state.page+=1;render();};}function pageItems(state){const from=(state.page-1)*state.pageSize;return state.rows.slice(from,from+state.pageSize);}function chartBounds(histories,unit,showNormal,showThresholds){const values=[];for(const history of histories){for(const point of history.points||[])for(const value of [point.minimum_milli_celsius,point.average_milli_celsius,point.maximum_milli_celsius]){const converted=toChartValue(value,unit);if(Number.isFinite(converted))values.push(converted);}const visual=history.visual_parameters||{};if(showNormal)for(const value of [visual.normal_low_f,visual.normal_high_f]){const converted=displayFahrenheit(value,unit);if(Number.isFinite(converted))values.push(converted);}if(showThresholds)for(const value of [visual.low_open_threshold_f,visual.high_open_threshold_f]){const converted=displayFahrenheit(value,unit);if(Number.isFinite(converted))values.push(converted);}}if(!values.length)return{};const low=Math.min(...values),high=Math.max(...values),padding=Math.max((high-low)*.08,1);return{min:low-padding,max:high+padding};}function v09TemperatureChartOption(histories,unit,showNormal,showThresholds){const colors=chartPalette(),series=histories.map((history,index)=>{const visual=history.visual_parameters||{},normalLow=displayFahrenheit(visual.normal_low_f,unit),normalHigh=displayFahrenheit(visual.normal_high_f,unit),high=displayFahrenheit(visual.high_open_threshold_f,unit),low=displayFahrenheit(visual.low_open_threshold_f,unit),label=history.sensor_label||history.sensor_id,seriesOption={name:label,type:'line',showSymbol:true,symbolSize:5,connectNulls:false,data:(history.points||[]).map(point=>({value:[point.bucket_start,toChartValue(point.average_milli_celsius,unit)],minimum:toChartValue(point.minimum_milli_celsius,unit),maximum:toChartValue(point.maximum_milli_celsius,unit),coverage:point.temperature_covered_seconds})),emphasis:{focus:'series'},lineStyle:{width:2.5},itemStyle:{color:colors[index%colors.length]}};if(showNormal&&normalLow!==null&&normalHigh!==null)seriesOption.markArea={silent:true,itemStyle:{color:'#23895c2b'},label:{show:true,position:'inside',color:'rgba(31,112,70,.62)',fontWeight:700,fontSize:11,formatter:`${label} working temperature`},data:[[{yAxis:normalLow},{yAxis:normalHigh}]]};if(showThresholds){const lines=[];if(low!==null)lines.push({name:`${label} low threshold`,yAxis:low,lineStyle:{type:'dashed',color:'#3b7dd8'},label:{formatter:'Low threshold'}});if(high!==null)lines.push({name:`${label} high threshold`,yAxis:high,lineStyle:{type:'dashed',color:'#d85427'},label:{formatter:'High threshold'}});if(lines.length)seriesOption.markLine={symbol:'none',silent:true,data:lines};}return seriesOption;});return{animation:!window.matchMedia('(prefers-reduced-motion: reduce)').matches,color:colors,grid:{left:72,right:122,top:62,bottom:88,containLabel:false},legend:{type:'scroll',top:8},tooltip:{trigger:'axis',axisPointer:{type:'cross'},formatter:items=>{const at=items[0]?.value?.[0],rows=items.map(item=>`${esc(item.seriesName)}: <strong>${Number(item.value?.[1]).toFixed(1)}°${unit==='celsius'?'C':'F'}</strong> <span>(${Number(item.data?.minimum).toFixed(1)}–${Number(item.data?.maximum).toFixed(1)}°)</span>`).join('<br>');return `<strong>${new Date(at).toLocaleString()}</strong><br>${rows}`;}},xAxis:{type:'time',name:'Time',nameLocation:'middle',nameGap:30,axisLabel:{hideOverlap:true}},yAxis:{type:'value',name:`Temperature °${unit==='celsius'?'C':'F'}`,...chartBounds(histories,unit,showNormal,showThresholds),axisLabel:{formatter:value=>`${value}°`},splitLine:{lineStyle:{type:'dashed'}}},dataZoom:[{type:'inside',filterMode:'none'},{type:'slider',height:22,bottom:20,filterMode:'none'}],toolbox:{right:12,top:4,feature:{dataZoom:{yAxisIndex:'none'},restore:{}}},series};}function v09RenderTemperatureTable(histories,unit){temperatureTableState.rows=histories.flatMap(history=>(history.points||[]).map(point=>({label:history.sensor_label||history.sensor_id,point}))).sort((a,b)=>new Date(b.point.bucket_start)-new Date(a.point.bucket_start));const render=()=>{const rows=pageItems(temperatureTableState);$('#temperature-history-rows').innerHTML=rows.length?rows.map(({label,point})=>`<tr><td>${esc(label)}</td><td>${esc(new Date(point.bucket_start).toLocaleString())}</td><td>${displayTemperature(point.minimum_milli_celsius,unit)}</td><td>${displayTemperature(point.average_milli_celsius,unit)}</td><td>${displayTemperature(point.maximum_milli_celsius,unit)}</td><td>${Math.round(Number(point.temperature_covered_seconds||0)/60)} min</td></tr>`).join(''):'<tr><td colspan=6 class=muted>No completed temperature intervals are available for the selected sensors.</td></tr>';$('#temperature-history-pagination').innerHTML=paginationMarkup('temperature-history',temperatureTableState,temperatureTableState.rows.length);bindPagination('temperature-history',temperatureTableState,render);};render();}async function v09LoadTemperature(){const request=++temperatureRequest,response=await api('/api/v1/me/sensors');if(!response.ok)throw new Error('sensors unavailable');const data=await response.json();if(request!==temperatureRequest)return;const activeSensors=(data.sensors||[]).filter(sensor=>sensor.monitoring_status==='active'&&(sensor.measurement_types||[]).includes('temperature')),selected=selectedSensorIds(activeSensors);renderTemperaturePicker(activeSensors,selected);if(!selected.length){disposeTemperatureChart();$('#temperature-freshness').textContent='Select one or more commissioned temperature sensors.';$('#temperature-chart').innerHTML='<p class=muted>No sensor is selected.</p>';temperatureTableState.rows=[];temperatureTableState.page=1;$('#temperature-history-rows').innerHTML='<tr><td colspan=6 class=muted>Select sensors to view history.</td></tr>';$('#temperature-history-pagination').innerHTML='';return;}const days=Number($('#temperature-range').value),end=new Date(),start=new Date(end.getTime()-days*86400000),histories=await Promise.all(selected.map(async deviceId=>{const historyResponse=await api(`/api/v1/me/temperature/${encodeURIComponent(deviceId)}?start=${encodeURIComponent(start.toISOString())}&end=${encodeURIComponent(end.toISOString())}`);if(!historyResponse.ok)throw new Error('temperature history unavailable');return historyResponse.json();}));if(request!==temperatureRequest)return;const primary=histories[0]?.visual_parameters?.display_unit||'fahrenheit';$('#temperature-freshness').textContent=histories.map(history=>`${history.sensor_label||'Sensor'}: ${String(history.freshness||'unavailable').replaceAll('_',' ')}`).join(' · ');renderTemperatureChart(histories,primary);renderTemperatureTable(histories,primary);}function alertTooltip(a,unit){return `<strong>${esc(a.sensor_label||a.source_device_id||'Sensor')} · ${esc(a.alarm_type)} alarm</strong><br>Status: ${esc(a.state)} · Severity: ${esc(a.severity)}<br>Opened: ${new Date(a.opened_at).toLocaleString()} · ${displayTemperature(a.opened_value_milli_celsius,unit)}<br>${a.cleared_at?`Cleared: ${new Date(a.cleared_at).toLocaleString()} · ${displayTemperature(a.cleared_value_milli_celsius,unit)}<br>`:'Still open<br>'}Average: ${displayTemperature(a.average_value_milli_celsius,unit)}`;}function v09AlertChartOption(alerts,unit){const colors=chartPalette(),now=Date.now(),groups=new Map();alerts.slice().sort((a,b)=>new Date(a.opened_at)-new Date(b.opened_at)).forEach(alert=>{const key=`${alert.sensor_label||alert.source_device_id||'Sensor'} · ${alert.alarm_type}`;if(!groups.has(key))groups.set(key,[]);groups.get(key).push(alert);});const series=[...groups.entries()].map(([name,items],index)=>({name,type:'custom',coordinateSystem:'cartesian2d',renderItem(params,api){const start=api.coord([api.value(0),0]),end=api.coord([api.value(1),1]),shape=echarts.graphic.clipRectByRect({x:start[0],y:end[1],width:Math.max(2,end[0]-start[0]),height:start[1]-end[1]},params.coordSys);return shape&&{type:'rect',shape,style:api.style({fill:colors[index%colors.length],opacity:.62,stroke:colors[index%colors.length],lineWidth:1})};},encode:{x:[0,1],y:2},data:items.map(alert=>({value:[new Date(alert.opened_at).getTime(),alert.cleared_at?new Date(alert.cleared_at).getTime():now,1],alert})),tooltip:{formatter:item=>alertTooltip(item.data.alert,unit)}}));return{animation:!window.matchMedia('(prefers-reduced-motion: reduce)').matches,color:colors,grid:{left:76,right:30,top:62,bottom:88},legend:{type:'scroll',top:8},tooltip:{trigger:'item'},xAxis:{type:'time',name:'Time',nameLocation:'middle',nameGap:30},yAxis:{type:'value',name:'Alarm state',min:0,max:1,interval:1,axisLabel:{formatter:value=>value?'Alarm':'Clear'},splitLine:{show:false}},dataZoom:[{type:'inside',filterMode:'none'},{type:'slider',height:22,bottom:20,filterMode:'none'}],toolbox:{right:12,top:4,feature:{dataZoom:{yAxisIndex:'none'},restore:{}}},series};}function alertCard(alarm,unit){const durationEnd=alarm.cleared_at?new Date(alarm.cleared_at):new Date(),duration=Math.max(0,Math.round((durationEnd-new Date(alarm.opened_at))/60000));return `<article class='alert-card ${esc(alarm.state)}'><div class='alert-card-title'><strong>${esc(alarm.sensor_label||alarm.source_device_id||'Sensor')} · ${esc(alarm.alarm_type)} temperature alarm</strong><span>${esc(alarm.state)} · ${esc(alarm.severity)}</span></div><dl class='alert-details'><div><dt>Opened</dt><dd>${esc(new Date(alarm.opened_at).toLocaleString())} · ${displayTemperature(alarm.opened_value_milli_celsius,unit)}</dd></div><div><dt>Cleared</dt><dd>${alarm.cleared_at?`${esc(new Date(alarm.cleared_at).toLocaleString())} · ${displayTemperature(alarm.cleared_value_milli_celsius,unit)}`:'Open'}</dd></div><div><dt>Average temperature</dt><dd>${displayTemperature(alarm.average_value_milli_celsius,unit)}</dd></div><div><dt>Duration</dt><dd>${duration} min</dd></div></dl>${alarm.clear_reason?`<p class=muted>Clear reason: ${esc(alarm.clear_reason)}</p>`:''}</article>`;}function v09RenderAlerts(alerts){const unit='fahrenheit';disposeAlertChart();if(alerts.length){$('#alert-chart').innerHTML='<div id=alerts-echart class=analytical-chart role=img aria-label=Interactive-alert-timeline></div>';alertChart=echarts.init($('#alerts-echart'),chartTheme(),{renderer:'canvas'});alertChart.setOption(alertChartOption(alerts,unit),true);}else $('#alert-chart').innerHTML='<p class=muted>No alerts match the selected filters.</p>';alertListState.rows=alerts.slice().sort((a,b)=>new Date(b.opened_at)-new Date(a.opened_at));const render=()=>{const alerts=pageItems(alertListState);$('#alert-list').innerHTML=alerts.length?alerts.map(alarm=>alertCard(alarm,unit)).join(''):'<div class=empty-state><h2>No alerts to show</h2><p>Your alert history will appear here after an alarm opens.</p></div>';$('#alert-list-pagination').innerHTML=paginationMarkup('alert-list',alertListState,alertListState.rows.length);bindPagination('alert-list',alertListState,render);};render();}async function v09LoadAlerts(){const request=++alertRequest,days=Number($('#alerts-range').value),end=new Date(),start=new Date(end.getTime()-days*86400000),response=await api(`/api/v1/me/alerts?start=${encodeURIComponent(start.toISOString())}&end=${encodeURIComponent(end.toISOString())}`);if(!response.ok)throw new Error('alerts unavailable');if(request!==alertRequest)return;const severity=$('#alerts-severity').value,type=$('#alerts-type').value,alerts=(await response.json()).filter(alert=>(severity==='all'||alert.severity===severity)&&(type==='all'||alert.alarm_type===type));alertListState.page=1;renderAlerts(alerts);}

renderTemperaturePicker=v09RenderTemperaturePicker;temperatureChartOption=v09TemperatureChartOption;renderTemperatureTable=v09RenderTemperatureTable;loadTemperature=v09LoadTemperature;alertChartOption=v09AlertChartOption;renderAlerts=v09RenderAlerts;loadAlerts=v09LoadAlerts;

// Customer presentation preferences apply only at the display boundary. Temperatures
// remain canonical Celsius values in storage and use the runtime profile for alarms.
async function loadCustomerDisplayPreference(){
  const response=await api('/api/v1/me/display-preferences');
  if(!response.ok)throw new Error('measurement settings unavailable');
  const preference=await response.json();
  customerDisplayUnit=preference.display_unit==='celsius'?'celsius':'fahrenheit';
  const field=$('#settings-temperature-unit');
  if(field)field.value=customerDisplayUnit;
}

function bindCustomerDisplayPreference(){
  const form=$('#display-preferences-form');
  if(!form)return;
  form.onsubmit=async event=>{
    event.preventDefault();
    const field=$('#settings-temperature-unit');
    const status=$('#settings-display-status');
    const response=await api('/api/v1/me/display-preferences',{
      method:'PATCH',body:JSON.stringify({display_unit:field.value}),
    });
    if(!response.ok)throw new Error('measurement settings could not be saved');
    const preference=await response.json();
    customerDisplayUnit=preference.display_unit==='celsius'?'celsius':'fahrenheit';
    field.value=customerDisplayUnit;
    status.textContent=`Temperature values are now shown in ${customerDisplayUnit==='celsius'?'Celsius (°C)':'Fahrenheit (°F)'}.`;
    if(!$('.customer-view[data-customer-panel="temperature"]')?.classList.contains('hidden'))await loadTemperature();
    if(!$('.customer-view[data-customer-panel="alerts"]')?.classList.contains('hidden'))await loadAlerts();
  };
}

function v091TemperatureChartOption(histories,unit,showNormal,showThresholds){
  const colors=chartPalette();
  const thresholdUnit=unit==='celsius'?'C':'F';
  const legendSelected={};
  for(const history of histories){
    const label=history.sensor_label||history.sensor_id;
    if(temperatureSeriesVisibilityBySensor.get(temperatureChartKey(history))===false)legendSelected[label]=false;
  }
  const thresholdLine=(value,name,color)=>({
    name,
    yAxis:value,
    lineStyle:{type:'dashed',color},
    label:{show:true,position:'end',color,fontWeight:600,formatter:`${Number(value).toFixed(1)}°${thresholdUnit} ${name}`},
  });
  const series=histories.map((history,index)=>{
    const visual=history.visual_parameters||{};
    const normalLow=displayFahrenheit(visual.normal_low_f,unit);
    const normalHigh=displayFahrenheit(visual.normal_high_f,unit);
    const high=displayFahrenheit(visual.high_open_threshold_f,unit);
    const low=displayFahrenheit(visual.low_open_threshold_f,unit);
    const label=history.sensor_label||history.sensor_id;
    const seriesOption={
      name:label,type:'line',showSymbol:true,symbolSize:5,connectNulls:false,
      data:(history.points||[]).map(point=>({
        value:[point.bucket_start,toChartValue(point.average_milli_celsius,unit)],
        minimum:toChartValue(point.minimum_milli_celsius,unit),
        maximum:toChartValue(point.maximum_milli_celsius,unit),
        coverage:point.temperature_covered_seconds,
      })),
      emphasis:{focus:'series'},lineStyle:{width:2.5},itemStyle:{color:colors[index%colors.length]},
    };
    if(showNormal&&normalLow!==null&&normalHigh!==null)seriesOption.markArea={
      silent:true,itemStyle:{color:'#23895c2b'},
      label:{show:true,position:'inside',color:'rgba(31,112,70,.62)',fontWeight:700,fontSize:11,formatter:`${label} working temperature`},
      data:[[{yAxis:normalLow},{yAxis:normalHigh}]],
    };
    if(showThresholds){
      const lines=[];
      if(low!==null)lines.push(thresholdLine(low,'Low threshold','#3b7dd8'));
      if(high!==null)lines.push(thresholdLine(high,'High threshold','#d85427'));
      if(lines.length)seriesOption.markLine={symbol:'none',silent:true,data:lines};
    }
    return seriesOption;
  });
  return {
    animation:!window.matchMedia('(prefers-reduced-motion: reduce)').matches,color:colors,
    grid:{left:72,right:172,top:62,bottom:88,containLabel:false},legend:{type:'scroll',top:8,selected:legendSelected},
    tooltip:{trigger:'axis',axisPointer:{type:'cross'},formatter:items=>{
      const at=items[0]?.value?.[0];
      const rows=items.map(item=>`${esc(item.seriesName)}: <strong>${Number(item.value?.[1]).toFixed(1)}°${thresholdUnit}</strong> <span>(${Number(item.data?.minimum).toFixed(1)}–${Number(item.data?.maximum).toFixed(1)}°)</span>`).join('<br>');
      return `<strong>${new Date(at).toLocaleString()}</strong><br>${rows}`;
    }},
    xAxis:{type:'time',name:'Time',nameLocation:'middle',nameGap:30,axisLabel:{hideOverlap:true}},
    yAxis:{type:'value',name:`Temperature °${thresholdUnit}`,...chartBounds(histories,unit,showNormal,showThresholds),axisLabel:{formatter:formatTemperatureAxisValue},splitLine:{lineStyle:{type:'dashed'}}},
    series,
  };
}

async function v091LoadTemperature(windowOverride=null){
  const selectedWindow=windowOverride||selectedTemperatureWindow();
  if(!selectedWindow)return;
  const windowStart=Math.round(selectedWindow.start),windowEnd=Math.round(selectedWindow.end);
  if(!Number.isFinite(windowStart)||!Number.isFinite(windowEnd)||windowStart>=windowEnd)return;
  const request=++temperatureRequest;
  const response=await api('/api/v1/me/sensors');
  if(!response.ok)throw new Error('sensors unavailable');
  const data=await response.json();
  if(request!==temperatureRequest)return;
  const activeSensors=(data.sensors||[]).filter(sensor=>sensor.monitoring_status==='active'&&(sensor.measurement_types||[]).includes('temperature'));
  const selected=selectedSensorIds(activeSensors);
  renderTemperaturePicker(activeSensors,selected);
  if(!selected.length){
    disposeTemperatureChart();
    $('#temperature-freshness').textContent='Select one or more commissioned temperature sensors.';
    $('#temperature-chart').innerHTML='<p class=muted>No sensor is selected.</p>';
    temperatureTableState.rows=[];temperatureTableState.page=1;
    $('#temperature-history-rows').innerHTML='<tr><td colspan=6 class=muted>Select sensors to view history.</td></tr>';
    $('#temperature-history-pagination').innerHTML='';
    temperatureChartHistories=[];
    temperatureChartContext=null;
    return;
  }
  const rangeMilliseconds=windowEnd-windowStart;
  // Retain the same amount of history on both sides of the visible window,
  // subject to the API's 366-day limit.  This gives panning room in either
  // direction while the selected time scale remains locked.
  const bufferMilliseconds=Math.min(rangeMilliseconds,Math.max(0,(maximumTemperatureRangeMilliseconds-rangeMilliseconds)/2));
  const contextStart=Math.round(windowStart-bufferMilliseconds);
  const contextEnd=Math.min(Math.round(windowEnd+bufferMilliseconds),Date.now());
  const histories=await Promise.all(selected.map(async deviceId=>{
    const historyResponse=await api(`/api/v1/me/temperature/${encodeURIComponent(deviceId)}?start=${encodeURIComponent(new Date(contextStart).toISOString())}&end=${encodeURIComponent(new Date(contextEnd).toISOString())}`);
    if(!historyResponse.ok)throw new Error('temperature history unavailable');
    return historyResponse.json();
  }));
  if(request!==temperatureRequest)return;
  $('#temperature-freshness').textContent=histories.map(history=>`${history.sensor_label||'Sensor'}: ${String(history.freshness||'unavailable').replaceAll('_',' ')}`).join(' · ');
  temperatureChartWindow={start:windowStart,end:windowEnd};
  temperatureChartContext={start:contextStart,end:contextEnd};
  temperatureChartHistories=histories;
  temperatureChartUnit=customerDisplayUnit;
  setTemperatureDateInputs(temperatureChartWindow);
  renderTemperatureChart(histories,customerDisplayUnit);
  renderTemperatureTable(temperatureHistoryForWindow(histories,temperatureChartWindow),customerDisplayUnit);
}

function v091AlertChartOption(alerts,unit,range){
  const colors=chartPalette();
  const darkColors=['#064f65','#7b2d17','#3f2c79','#07573f','#6f3a0e','#74274f','#324b7a','#3e5015'];
  const groups=new Map();
  alerts.slice().sort((a,b)=>new Date(a.opened_at)-new Date(b.opened_at)).forEach(alert=>{
    const key=`${alert.sensor_label||alert.source_device_id||'Sensor'} · ${alert.alarm_type}`;
    if(!groups.has(key))groups.set(key,[]);
    groups.get(key).push(alert);
  });
  const keys=[...groups.keys()];
  const series=[...groups.entries()].map(([name,items],colorIndex)=>{
    // One palette index is used for both the legend and the custom rectangle.
    // Hiding a legend item does not rebuild this list, so the remaining
    // visible series keeps its original color.
    colorIndex%=colors.length;
    const color=colors[colorIndex],watermark=darkColors[colorIndex%darkColors.length];
    const data=items.map(alert=>{
      const opened=Math.max(new Date(alert.opened_at).getTime(),range.start.getTime());
      const ended=Math.min(alert.cleared_at?new Date(alert.cleared_at).getTime():range.end.getTime(),range.end.getTime());
      return ended>=opened?{value:[opened,ended],alert}:null;
    }).filter(Boolean);
    return {
      name,type:'custom',coordinateSystem:'cartesian2d',
      itemStyle:{color},
      renderItem(params,api){
        const left=api.coord([api.value(0),0.14]);
        const right=api.coord([api.value(1),0.86]);
        const shape=echarts.graphic.clipRectByRect({
          x:Math.min(left[0],right[0]),y:Math.min(left[1],right[1]),
          width:Math.max(2,Math.abs(right[0]-left[0])),height:Math.abs(right[1]-left[1]),
        },params.coordSys);
        if(!shape)return null;
        return {type:'group',children:[
          {type:'rect',shape,style:{fill:color,opacity:.7,stroke:color,lineWidth:1}},
          {type:'text',rotation:-Math.PI/2,origin:[shape.x+shape.width/2,shape.y+shape.height/2],style:{
            x:shape.x+shape.width/2,y:shape.y+shape.height/2,text:'ALERT',fill:watermark,
            font:'700 11px sans-serif',textAlign:'center',textVerticalAlign:'middle',opacity:.9,
          }},
        ]};
      },
      encode:{x:[0,1]},data,tooltip:{formatter:item=>alertTooltip(item.data.alert,unit)},
    };
  });
  return {
    animation:!window.matchMedia('(prefers-reduced-motion: reduce)').matches,color:colors,
    grid:{left:76,right:30,top:62,bottom:88},legend:{type:'scroll',top:8},tooltip:{trigger:'item'},
    xAxis:{type:'time',min:range.start.getTime(),max:range.end.getTime(),name:'Time',nameLocation:'middle',nameGap:30,axisLabel:{hideOverlap:true}},
    yAxis:{type:'value',name:'Alarm state',min:0,max:1,interval:1,axisLabel:{formatter:value=>value?'Alarm':'Clear'},splitLine:{show:false}},
    dataZoom:[{type:'inside',xAxisIndex:0,filterMode:'none',zoomOnMouseWheel:true,moveOnMouseWheel:false,moveOnMouseMove:true,preventDefaultMouseMove:true},{type:'slider',xAxisIndex:0,height:22,bottom:20,filterMode:'none'}],
    toolbox:{right:12,top:4,feature:{dataZoom:{yAxisIndex:'none'},restore:{}}},series,
  };
}

function v091RenderAlerts(alerts,range){
  const unit=customerDisplayUnit;
  disposeAlertChart();
  if(alerts.length){
    $('#alert-chart').innerHTML='<div id=alerts-echart class=analytical-chart role=img aria-label=Interactive alert timeline; drag horizontally to pan and scroll to zoom></div>';
    alertChart=echarts.init($('#alerts-echart'),chartTheme(),{renderer:'canvas'});
    alertChart.setOption(alertChartOption(alerts,unit,range),true);
  }else $('#alert-chart').innerHTML='<p class=muted>No alerts match the selected filters in this time range.</p>';
  alertListState.rows=alerts.slice().sort((a,b)=>new Date(b.opened_at)-new Date(a.opened_at));
  const render=()=>{
    const alerts=pageItems(alertListState);
    $('#alert-list').innerHTML=alerts.length?alerts.map(alarm=>alertCard(alarm,unit)).join(''):'<div class=empty-state><h2>No alerts to show</h2><p>Your alert history will appear here after an alarm opens.</p></div>';
    $('#alert-list-pagination').innerHTML=paginationMarkup('alert-list',alertListState,alertListState.rows.length);
    bindPagination('alert-list',alertListState,render);
  };
  render();
}

async function v091LoadAlerts(){
  const request=++alertRequest;
  const days=Number($('#alerts-range').value),end=new Date(),start=new Date(end.getTime()-days*86400000);
  const response=await api(`/api/v1/me/alerts?start=${encodeURIComponent(start.toISOString())}&end=${encodeURIComponent(end.toISOString())}`);
  if(!response.ok)throw new Error('alerts unavailable');
  if(request!==alertRequest)return;
  const severity=$('#alerts-severity').value,type=$('#alerts-type').value;
  const alerts=(await response.json()).filter(alert=>(severity==='all'||alert.severity===severity)&&(type==='all'||alert.alarm_type===type));
  alertListState.page=1;
  renderAlerts(alerts,{start,end});
}

temperatureChartOption=v091TemperatureChartOption;
loadTemperature=v091LoadTemperature;
alertChartOption=v091AlertChartOption;
renderAlerts=v091RenderAlerts;
loadAlerts=v091LoadAlerts;

// The selected period is an upper bound.  Keep the axis focused on the actual
// completed history returned by the analytics service so sparse data is never
// stretched across 7, 30, or 365 days.
function v092AvailableTemperatureWindow(histories){
  const timestamps=histories.flatMap(history=>(history.points||[])
    .map(point=>new Date(point.bucket_start).getTime()).filter(Number.isFinite));
  if(!timestamps.length)return {};
  const first=Math.min(...timestamps),last=Math.max(...timestamps);
  const padding=Math.max(60_000,Math.min(21_600_000,Math.max((last-first)*.02,60_000)));
  return {min:first-padding,max:last+padding};
}

function v092SignedTemperature(value,unit){
  const numeric=Number(value);
  if(!Number.isFinite(numeric))return '—';
  const prefix=numeric>0?'+':'';
  return `${prefix}${numeric.toFixed(1)}°${unit==='celsius'?'C':'F'}`;
}

const v091TemperatureChartOptionBase=v091TemperatureChartOption;
function v092TemperatureChartOption(histories,unit,showNormal,showThresholds){
  const option=v091TemperatureChartOptionBase(histories,unit,showNormal,showThresholds);
  option.xAxis={...option.xAxis,...v092AvailableTemperatureWindow(histories)};
  for(const series of option.series){
    for(const line of series.markLine?.data||[]){
      const label=line.name||'Threshold';
      line.label={...line.label,formatter:`${v092SignedTemperature(line.yAxis,unit)} ${label}`};
    }
  }
  return option;
}

temperatureChartOption=v092TemperatureChartOption;

// ECharts owns both wheel zoom and direct-drag pan. Keeping them in one
// inside-dataZoom controller preserves the zoomed window while it is panned.
// The datazoom event keeps selected cards, date controls, and the table in sync.
function v113CustomerTimeNavigation(){
  const range={startValue:temperatureChartWindow?.start,endValue:temperatureChartWindow?.end};
  return [
    {
      type:'inside',xAxisIndex:0,filterMode:'none',...range,
      zoomLock:false,zoomOnMouseWheel:true,moveOnMouseWheel:false,moveOnMouseMove:true,
      preventDefaultMouseMove:true,
    },
    {
      type:'slider',xAxisIndex:0,filterMode:'none',...range,
      height:22,bottom:20,
    },
  ];
}
const v113TemperatureChartOptionBase=temperatureChartOption;
function v113TemperatureChartOption(histories,unit,showNormal,showThresholds){
  const option=v113TemperatureChartOptionBase(histories,unit,showNormal,showThresholds);
  if(temperatureChartContext){
    option.xAxis={...option.xAxis,min:temperatureChartContext.start,max:temperatureChartContext.end};
  }
  option.dataZoom=v113CustomerTimeNavigation();
  option.animationDurationUpdate=180;
  option.animationEasingUpdate='cubicOut';
  return option;
}
temperatureChartOption=v113TemperatureChartOption;

// Architecture v1.2 ComPower is a separate customer workspace.  It exposes
// only explicitly commissioned electrical sub-sensors; diagnostic humidity,
// LQI, and unclassified catalog channels remain Staff-only until a pack adopts
// them.  Its charts reuse the same wheel-zoom + click-drag-pan interaction.
customerViewTitles.compower='ComPower';
let compowerCharts=[];
let selectedComPowerMonitorId='';
let compowerMonitors=[];

function disposeComPowerCharts(){
  for(const chart of compowerCharts){try{chart.dispose();}catch{}}
  compowerCharts=[];
}

function compowerRoleLabel(role){return ({voltage:'Voltage',current:'Current',active_power:'Active power'})[role]||role.replaceAll('_',' ');}
function compowerTimeNavigation(){
  return [
    {type:'inside',xAxisIndex:0,filterMode:'none',zoomLock:false,zoomOnMouseWheel:true,moveOnMouseWheel:false,moveOnMouseMove:true,preventDefaultMouseMove:true},
    {type:'slider',xAxisIndex:0,filterMode:'none',height:22,bottom:20},
  ];
}

function compowerChartOption(role,unit,points){
  return {
    animation:!window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    color:chartPalette(),grid:{left:72,right:32,top:38,bottom:72},
    tooltip:{trigger:'axis',axisPointer:{type:'cross'},formatter:items=>{
      const item=items?.[0],point=item?.data?.point;
      return point?`<strong>${esc(new Date(point.observed_at).toLocaleString())}</strong><br>${esc(Number(point.numeric_value).toLocaleString(undefined,{maximumFractionDigits:3}))} ${esc(unit)}`:'';
    }},
    xAxis:{type:'time',name:'Time',nameLocation:'middle',nameGap:30,axisLabel:{hideOverlap:true}},
    yAxis:{type:'value',name:`${compowerRoleLabel(role)} (${unit})`,scale:true,splitLine:{lineStyle:{type:'dashed'}}},
    dataZoom:compowerTimeNavigation(),
    series:[{name:compowerRoleLabel(role),type:'line',showSymbol:true,symbolSize:5,connectNulls:false,lineStyle:{width:2.5},data:points.map(point=>({value:[point.observed_at,Number(point.numeric_value)],point}))}],
  };
}

function compowerProfileParameters(form,previous={}){
  const value=name=>Number(new FormData(form).get(name));
  return {
    silence_timeout_seconds:value('silence_minutes')*60,
    voltage_low_v:value('voltage_low_v'),voltage_high_v:value('voltage_high_v'),current_high_a:value('current_high_a'),
    electrical_auto_clear_seconds:value('electrical_clear_minutes')*60,
    notification_enabled:Boolean(previous.notification_enabled),
    linked_evidence_clear_enabled:Boolean(previous.linked_evidence_clear_enabled),
  };
}

function compowerProfileMarkup(monitor){
  const p=monitor.profile_parameters||{};
  return `<form id="compower-profile-form" class="profile-form"><div class="profile-fields">
    <label>Reporting timeout (minutes)<input name="silence_minutes" type="number" min="1" max="1440" value="${esc(Math.round(Number(p.silence_timeout_seconds||600)/60))}" required></label>
    <label>Low voltage (V)<input name="voltage_low_v" type="number" min="0" step="0.1" value="${esc(p.voltage_low_v??70)}" required></label>
    <label>High voltage (V)<input name="voltage_high_v" type="number" min="0" step="0.1" value="${esc(p.voltage_high_v??140)}" required></label>
    <label>Maximum current (A)<input name="current_high_a" type="number" min="0.1" step="0.1" value="${esc(p.current_high_a??12)}" required></label>
    <label>Electrical auto-clear (minutes)<input name="electrical_clear_minutes" type="number" min="1" max="1440" value="${esc(Math.round(Number(p.electrical_auto_clear_seconds||1800)/60))}" required></label>
  </div>${mockSession?'<p class="muted">Mock sessions are read only.</p>':'<button class="button" type="submit">Save outlet parameters</button>'}</form>`;
}

function compowerIncidentMarkup(incident){
  const durationEnd=incident.cleared_at?new Date(incident.cleared_at):new Date();
  const minutes=Math.max(0,Math.round((durationEnd-new Date(incident.opened_at))/60000));
  const type=incident.incident_type.replaceAll('_',' ');
  const opened=incident.opened_value===null||incident.opened_value===undefined?'—':`${Number(incident.opened_value).toLocaleString()} ${incident.opened_unit||''}`;
  return `<article class="alert-card ${esc(incident.state)}"><div class="alert-card-title"><strong>${esc(incident.sensor_label||incident.source_device_id)} · ${esc(type)}</strong><span>${esc(incident.state)} · ${esc(incident.severity)}</span></div><dl class="alert-details"><div><dt>Opened</dt><dd>${esc(new Date(incident.opened_at).toLocaleString())} · ${esc(opened)}</dd></div><div><dt>Cleared</dt><dd>${incident.cleared_at?esc(new Date(incident.cleared_at).toLocaleString()):'Open'}</dd></div><div><dt>Duration</dt><dd>${minutes} min</dd></div></dl>${incident.clear_reason?`<p class="muted">Clear reason: ${esc(incident.clear_reason.replaceAll('_',' '))}</p>`:''}</article>`;
}

async function loadComPower(){
  const monitorsResponse=await api('/api/v1/me/compower/monitors');
  if(!monitorsResponse.ok)throw new Error('ComPower outlets unavailable');
  compowerMonitors=await monitorsResponse.json();
  if(!compowerMonitors.some(monitor=>monitor.monitor_id===selectedComPowerMonitorId))selectedComPowerMonitorId=compowerMonitors[0]?.monitor_id||'';
  const select=$('#compower-monitor-select');
  $('#compower-range').onchange=()=>loadComPower().catch(showError);
  select.innerHTML=compowerMonitors.length?compowerMonitors.map(monitor=>`<option value="${esc(monitor.monitor_id)}" ${monitor.monitor_id===selectedComPowerMonitorId?'selected':''}>${esc(monitor.sensor_label||monitor.source_device_id)} · ${esc(monitor.source_device_id)}</option>`).join(''):'<option value="">No commissioned outlets</option>';
  select.onchange=()=>{selectedComPowerMonitorId=select.value;loadComPower().catch(showError);};
  if(!selectedComPowerMonitorId){disposeComPowerCharts();$('#compower-charts').innerHTML='<p class="muted">No ComPower outlet is commissioned for this customer.</p>';$('#compower-status').textContent='';$('#compower-profile').innerHTML='';$('#compower-incidents').innerHTML='<p class="muted">No ComPower incidents are available.</p>';return;}
  const days=Number($('#compower-range').value),end=new Date(),start=new Date(end.getTime()-days*86400000);
  const [seriesResponse,incidentsResponse]=await Promise.all([
    api(`/api/v1/me/compower/monitors/${encodeURIComponent(selectedComPowerMonitorId)}/series?start=${encodeURIComponent(start.toISOString())}&end=${encodeURIComponent(end.toISOString())}`),
    api(`/api/v1/me/compower/incidents?start=${encodeURIComponent(start.toISOString())}&end=${encodeURIComponent(end.toISOString())}`),
  ]);
  if(!seriesResponse.ok)throw new Error('ComPower history unavailable');
  if(!incidentsResponse.ok)throw new Error('ComPower incidents unavailable');
  const history=await seriesResponse.json(), incidents=await incidentsResponse.json();
  const selectedMonitor=compowerMonitors.find(monitor=>monitor.monitor_id===selectedComPowerMonitorId)||history;
  $('#compower-status').textContent=`Last accepted outlet reading: ${history.last_eligible_received_at?new Date(history.last_eligible_received_at).toLocaleString():'not received yet'}`;
  disposeComPowerCharts();
  const grouped=new Map();
  for(const point of history.points||[]){if(!grouped.has(point.input_role))grouped.set(point.input_role,[]);grouped.get(point.input_role).push(point);}
  $('#compower-charts').innerHTML=[...grouped.entries()].map(([role,points],index)=>`<section class="temperature-chart-card"><div class="temperature-chart-heading"><h2>${esc(compowerRoleLabel(role))}</h2></div><p class="chart-pan-hint">Drag left or right, or use the slider, to explore history. Scroll to zoom the time scale.</p><div id="compower-chart-${index}" class="analytical-chart" role="img" aria-label="Interactive ${esc(compowerRoleLabel(role))} chart; drag horizontally to pan and scroll to zoom"></div></section>`).join('')||'<p class="muted">No retained electrical readings are available in this range.</p>';
  [...grouped.entries()].forEach(([role,points],index)=>{const chart=echarts.init($(`#compower-chart-${index}`),chartTheme(),{renderer:'canvas'});chart.setOption(compowerChartOption(role,points[0]?.unit||'',points),true);compowerCharts.push(chart);});
  $('#compower-incidents').innerHTML=incidents.filter(incident=>incident.monitor_id===selectedComPowerMonitorId).map(compowerIncidentMarkup).join('')||'<p class="muted">No ComPower incidents match this outlet and range.</p>';
  $('#compower-profile').innerHTML=compowerProfileMarkup(selectedMonitor);
  const profileForm=$('#compower-profile-form');
  if(profileForm)profileForm.onsubmit=async event=>{event.preventDefault();const response=await api(`/api/v1/me/compower/monitors/${encodeURIComponent(selectedComPowerMonitorId)}/profile`,{method:'PATCH',headers:{'X-Correlation-ID':crypto.randomUUID()},body:JSON.stringify({parameters:compowerProfileParameters(profileForm,selectedMonitor.profile_parameters)})});if(!response.ok)throw new Error('ComPower parameters could not be saved');message('ComPower outlet parameters saved.');await loadComPower();};
}

const v12OpenCustomerViewBase=openCustomerView;
openCustomerView=function v12OpenCustomerView(name){
  v12OpenCustomerViewBase(name);
  if(name==='compower')loadComPower().catch(showError);
};

const v12ResizeCustomerCharts=()=>{for(const chart of compowerCharts){try{chart.resize();}catch{}}};
window.addEventListener('resize',v12ResizeCustomerCharts);
